module.exports = __webpack_public_path__ + "bdabd76ab85f2dd7fd79d10b188bc5bb.svg";